import { BackSpace } from "../SVG/svg"

export const numdata = [
    {
        val:'1',
        operator:false,
    },

    {
        val:'2',
        operator:false
    },

    {
        val:'3',
        operator:false,
    },

    {
        val:'4',
        operator:false,
    },

    {
        val:'5',
        operator:false,
    },

    {
        val:'6',
        operator:false,
    },

    {
        val:'7',
        operator:false,
    },

    {
        val:'8',
        operator:false,
    },

    {
        val:'9',
        operator:false,
    },

    {
        val:'',
        svg:BackSpace(),
        operator:false,
    },

    {
        val:'0',
        operator:false
    },

]